import type { Currency, INavigationItem, LanguageCode } from '@anywayseo/tools';
import { graphql, useStaticQuery } from 'gatsby';


interface ISiteMetadata {
  title: string;
  description: string;
  siteUrl: string;
  lang: LanguageCode;
  currency: Currency;
  footerMenuLinks: INavigationItem[];
}

function useSiteMetadata(): ISiteMetadata {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          title
          description
          siteUrl
          lang
          currency
          footerMenuLinks {
            url
            title
          }
        }
      }
    }
  `);

  return data.site.siteMetadata;
}

export default useSiteMetadata;
